import {useMutation} from '@apollo/react-hooks';

import type {
    DeleteDomain as DeleteDomainMutation,
    DeleteDomainVariables as DeleteDomainMutationVariables,
    DomainDeleteInput,
} from 'nutshell-graphql-types';

import DELETE_DOMAIN from '../mutations/delete-domain.graphql';
import GET_DOMAIN_FEATURE_STATUSES from '../queries/get-domain-feature-statuses.graphql';
import GET_DOMAINS from '../queries/get-domains.graphql';

export function useDeleteDomain(): {
    deleteDomain: (arg1: DomainDeleteInput) => Promise<any>;
    isDeleting: boolean;
} {
    const [deleteDomain, {loading}] = useMutation<
        DeleteDomainMutation,
        DeleteDomainMutationVariables
    >(DELETE_DOMAIN, {
        refetchQueries: [{query: GET_DOMAIN_FEATURE_STATUSES}],
    });

    return {
        deleteDomain: (input: DomainDeleteInput) =>
            deleteDomain({
                variables: {domain: input},
                update: (proxy, mutationResults) => {
                    const deletedDomain =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.domainDelete &&
                        mutationResults.data.domainDelete.domain;

                    const cacheResult = proxy.readQuery({
                        query: GET_DOMAINS,
                    });

                    if (cacheResult && deletedDomain) {
                        proxy.writeQuery({
                            query: GET_DOMAINS,
                            data: {
                                // @ts-expect-error
                                domains: cacheResult.domains.filter(
                                    // @ts-expect-error
                                    (domain) => domain.id !== deletedDomain.id
                                ),
                            },
                        });
                    }
                },
            }),
        isDeleting: loading,
    };
}
